import React, {Component} from 'react'
import SignUp3 from '../components/SignUp3'


class Registration extends Component {
	render(){
		return <SignUp3/>
	}
}

export default Registration
